module.exports = __webpack_public_path__ + "static/img/bgc-img2.1839e570.png";